// extracted by mini-css-extract-plugin
module.exports = {"sections":"styles_sections__f4nE_","heroContact":"styles_heroContact___63xZ"};